<template>
    <div :class="[{'vs-sidebar-item-active':activeLink}, {'disabled-item pointer-events-none': isDisabled}]" class="vs-sidebar--item">
        <router-link v-if="to || pathName" :to="to!==null?to:{name: pathName}" :class="[{'router-link-active': activeLink}]" :target="target" exact>
          <feather-icon v-if="iconPack === 'feather'" :icon="icon" :class="{'w-3 h-3': iconSmall}"></feather-icon>
          <vs-icon v-else :icon-pack="iconPack" :icon="icon" />
          <slot></slot>
        </router-link>
        <a v-else :target="target" :href="href">
          <feather-icon v-if="iconPack === 'feather'" :icon="icon" :class="{'w-3 h-3': iconSmall}"></feather-icon>
          <vs-icon v-else :icon-pack="iconPack" :icon="icon" />
          <slot></slot>
        </a>
    </div>
</template>

<script>
export default {
    name: 'VxSidebarItem',
    props: {
        icon: {
            default: "",
            type: String
        },
        iconSmall: {
            default: false,
            type: Boolean,
        },
        iconPack: {
            default: 'material-icons',
            type: String
        },
        href: {
            default: '#',
            type: String
        },
        to: {
            default: null,
            type: String
        },
        index: {
            default: null,
            type: [String, Number]
        },
        target: {
            default: '_self',
            type: String,
        },
        isDisabled: {
            default: false,
            type: Boolean
        },
        pathName: {
            default: null,
            type: String,
        }
    },
    data() {
        return {
            activeLink: false,
        }
    },
    watch: {
        '$route'() {
            this.CheckIsActive()
        }
    },
    methods: {
        CheckIsActive() {
            this.activeLink = !!(this.to || this.pathName === this.$route.name);
        }
    },
    updated() {
        this.CheckIsActive();
    }
}
</script>
